import { render, staticRenderFns } from "./DashboardIndex.vue?vue&type=template&id=00dfad28&"
import script from "./DashboardIndex.vue?vue&type=script&lang=ts&"
export * from "./DashboardIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00dfad28')) {
      api.createRecord('00dfad28', component.options)
    } else {
      api.reload('00dfad28', component.options)
    }
    module.hot.accept("./DashboardIndex.vue?vue&type=template&id=00dfad28&", function () {
      api.rerender('00dfad28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Home/DashboardIndex.vue"
export default component.exports